const RESOURCE_NAME = '/xroutes';
// import axios from "@/api/http-auth";
import config from "@/config";
const baseURL = config.api.baseURL

export default axios => ({
    getAll(params) {
        return axios.get(`${RESOURCE_NAME}/users`, {params, baseURL});
    },
    assignedToRoute(userId, calculated_route_id, data, params = {}) {
        return axios.post(`${RESOURCE_NAME}/users/${userId}/assigned-to-route/${calculated_route_id}`, data, {params, baseURL});
    },
});